export var Name = 'user-logout-request';
export var UserLogoutRequestEvent = Name;